export const FIND_SPOT_FAILURE = 'FIND_SPOT_FAILURE';

export const findSpotFailure = (payload: Error) => ({
    type: FIND_SPOT_FAILURE,
    payload,
    error: true,
});
